import React, { useState } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';


export default function ResetPassword(props) {
    const navigate = useNavigate();
    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [smsCode, setSmsCode] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [formName, setFormName] = useState("request");

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "mobile") setMobile(val);
        else if(name === "password") setPassword(val);
        else if(name === "confirmPassword") setConfirmPassword(val);
        else if(name === "smsCode") {
            if((val == null)||(val == "")){
                setSmsCode(null);
            }
            else{
                setSmsCode(parseInt(val));
            }
        }
    }
    const checkRequestDataEntry = function(){
        var check = util.IsMobileValid(mobile);
        if(!check.valid){
            setErorVisible(true);
            setErrorMessage(check.msg);
            return false;
        }
        return true;
    }
    const requestSmsCode = function(){
        if(!checkRequestDataEntry()) return;
        setSaving(true);
        var params = {mobile:mobile};
        var url = config.Server+`/user/request-reset-password`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    setFormName("setPass");
                    setSaving(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const checkDataEntry = function(){
        if(smsCode == null){
            setErrorMessage("کد ریست کلمه عبور(پیامک شده به موبایل فوق) را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(smsCode <1000){
            setErrorMessage("کد ریست کلمه عبور عددی 4 رقمی است");
            setErorVisible(true);
            return false;
        }
        if(password.length == 0){
            setErrorMessage("کلمه عبور را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(password != confirmPassword){
            setErrorMessage("کلمه عبور و تکرار آن باید یکسان باشند");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {mobile:mobile, newPassword:password, smsCode:smsCode};
        var url = config.Server+`/user/set-new-password`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    setFormName("resetDone");
                    setSaving(false);

                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px"}}>
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>ریست کردن کلمه عبور</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                {
                                    formName == "request"?
                                    <>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="nationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                                    <label htmlFor="mobile">موبایل</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{textAlign:"right"}}>
                                            <React.Fragment>
                                                <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                                    <Button label="درخواست ریست کلمه عبور" icon="pi pi-check" onClick={()=>requestSmsCode()} loading={saving} severity="success" iconPos="right" style={{borderRadius:"5px"}} />
                                                </div>
                                            </React.Fragment>

                                            </td>
                                        </tr>
                                    </>
                                    :formName == "setPass"?
                                    <>
                                        <tr>
                                            <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr"}}>
                                                موبایل:{mobile}                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr><td>در کادر زیر کد 4 رقمی که به شماره موبایل فوق ارسال شده است ، ثبت کنید</td></tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={smsCode} onChange={(e)=>{onInputChange(e, "smsCode")}} id="smsCode" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                                    <label htmlFor="smsCode">کد ریست کلمه عبور</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <Password value={password} onChange={(e)=>{onInputChange(e, "password")}} id="password" maxLength={30} className="p-inputtext-lg" pt={{
                                                                    iconField: {
                                                                        root: {
                                                                        style: { width: "100%" },
                                                                        },
                                                                    },
                                                                    input: {
                                                                        style: { width: "100%", textAlign:"center" },
                                                                    },
                                                                    root: {
                                                                        style: { width: "100%" },
                                                                    },
                                                                    }} toggleMask feedback={false} />
                                                    <label htmlFor="password">کلمه عبور</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <Password value={confirmPassword} onChange={(e)=>{onInputChange(e, "confirmPassword")}} id="confirmPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                                                    iconField: {
                                                                        root: {
                                                                        style: { width: "100%" },
                                                                        },
                                                                    },
                                                                    input: {
                                                                        style: { width: "100%", textAlign:"center" },
                                                                    },
                                                                    root: {
                                                                        style: { width: "100%" },
                                                                    },
                                                                    }} toggleMask feedback={false} />
                                                    <label htmlFor="confirmPassword">تکرار کلمه عبور</label>
                                                </FloatLabel>
                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{textAlign:"right"}}>
                                            <React.Fragment>
                                                <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                                    <Button label="ثبت کلمه عبور جدید" icon="pi pi-check" onClick={()=>saveItem()} loading={saving} severity="success" iconPos="right" style={{borderRadius:"5px"}} />
                                                </div>
                                            </React.Fragment>

                                            </td>
                                        </tr>
                                    </>
                                    :
                                    <>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr><td>کلمه عبور با موفقیت بازنشانی گردید</td></tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{textAlign:"right"}}>
                                            <React.Fragment>
                                                <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                                    <Button label="برگشت به صقحه ورود" icon="pi pi-check" onClick={()=>navigate("/login")} loading={saving} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} />
                                                </div>
                                            </React.Fragment>

                                            </td>
                                        </tr>
                                    </>
                                }
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                        <div style={{width:"100%", paddingBottom:"10px"}}>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"10px"}}>
                                <Link to="/login" style={{textDecoration:"none", color:"#a0a0a0"}}>کلمه عبور دارم</Link>
                            </div>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"20px"}}>
                                <Link to="/request-membership" style={{textDecoration:"none", color:"#a0a0a0"}}>ثبت نام</Link>
                            </div>
                            <div style={{textAlign:"center", padding:"5px", direction:"rtl", borderTop:"1px dotted #b0b0b0", marginTop:"20px", borderBottom:"1px dotted #b0b0b0"}}>
                                تماس با ما: <label  style={{direction:"ltr"}}><a href="tel:08733741914">087 3374 1914</a></label>,&nbsp;&nbsp;&nbsp;
                                <label  style={{direction:"ltr"}}><a href="tel:08733741916">087 3374 1916</a></label>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}